import {setEffectPatternLocks} from 'actions/index.js';

export default superclass => class extends superclass  {
    get subSequence() {
        if (this._subSequence) {
            return this._subSequence;
        }

        if (!this.context) {
            return;
        }

        if (this.context.subSequence) {
            return this.context.subSequence;
        }

        let container = this.track ||
            this.context.track ||
            this.context.group;

        return container && container.subSequence;
    }

    dispatch(x) {
        let engine = (this.sequencerEngine || this.track.sequencerEngine);
        engine.dispatch(x);
    }

    get state() {
        let cont = (this.sequencerEngine || this.track);
        return cont && cont.state;
    }

    get currentPattern() {
        if (!this.state)  {
            return 0;
        }
        if (this.subSequence && this.subSequence.tracks[0]) {
            return this.subSequence.tracks[0].currentPattern;
        } else {
            return 0;
        }
    }

    get patternLocks() {
        if (!this.state) {
            return {};
        }
        return this.state.effects.effectPatternLocks[this.id] || {};
    }

    get locked() {
        return this.patternLocks[this.currentPattern];
    }

    set lock(lock) {
        this.lockPattern(this.currentPattern, lock);
    }

    lockPattern(patternNumber, lock) {
        let locks = {
            ... this.patternLocks
        };
        locks[patternNumber] = lock;
        this.dispatch(setEffectPatternLocks(
            this.id,
            locks));
    }
}
